import {
  deviceDefaultSetting,
  advancedBookingDefaultSetting,
  checkinDayDefaultSetting,
  userSetDatesDefaultSetting,
  checkinDateDefaultSetting,
  lengthOfStayDefaultSetting,
  defaultLocationData,
} from '@bingads-webui-campaign/hotel-common-targets';
import { audienceAdsOptionKeys, defaultAdFormat } from '@bingads-webui-campaign/hotel-common-upsert';
import { defaultName } from './adgroup-name';

const fields = {
  name: 'name',
  adFormat: 'adFormat',
  baseBid: 'baseBid',
  urlOptions: 'urlOptions',
  device: 'device',
  ABW: 'ABW',
  checkinDay: 'checkinDay',
  lengthOfStay: 'lengthOfStay',
  checkinDate: 'checkinDate',
  userSetDates: 'userSetDates',
  location: 'location',
  adSchedule: 'adSchedule',
  audienceAds: 'audienceAds',
};

const {
  name,
  adFormat,
  baseBid,
  urlOptions,
  device,
  location,
  adSchedule,
  ABW,
  checkinDay,
  lengthOfStay,
  checkinDate,
  userSetDates,
  audienceAds,
} = fields;

export const fieldsToCheck = [name, adFormat, adSchedule, audienceAds, location, baseBid, urlOptions, device, ABW, checkinDay, lengthOfStay, checkinDate, userSetDates];

export const defaultAdgroupBasicData = {
  name: {
    value: defaultName,
  },
  adSchedule: {
    useParentLevel: true,
  },
  dayTimeRanges: [],
  AdDistribution: 'BingYahooAndSearchPartners',
  adFormat: defaultAdFormat,
  baseBid: { value: '1.00' },
  exclusions: {},
  urlOptions: {},
  audienceAds: {
    parentLevelSettings: { option: audienceAdsOptionKeys.Increase, value: 0 },
    currentLevelSettings: { option: audienceAdsOptionKeys.Increase, value: 0 },
    useParentLevel: true,
  },
  location: {
    ...defaultLocationData,
    useParentLevel: true,
  },
  device: {
    parentLevelSettings: [...deviceDefaultSetting],
    currentLevelSettings: [...deviceDefaultSetting],
    useParentLevel: true,
  },
  ABW: {
    parentLevelSettings: [],
    currentLevelSettings: [...advancedBookingDefaultSetting],
    useParentLevel: true,
  },
  checkinDay: {
    parentLevelSettings: [...checkinDayDefaultSetting],
    currentLevelSettings: [...checkinDayDefaultSetting],
    useParentLevel: true,
  },
  userSetDates: {
    parentLevelSettings: [...userSetDatesDefaultSetting],
    currentLevelSettings: [...userSetDatesDefaultSetting],
    useParentLevel: true,
  },
  checkinDate: {
    parentLevelSettings: [],
    currentLevelSettings: [...checkinDateDefaultSetting],
    useParentLevel: true,
  },
  lengthOfStay: {
    parentLevelSettings: [],
    currentLevelSettings: [...lengthOfStayDefaultSetting],
    useParentLevel: true,
  },
};
